<template>
  <div class="label rounded-2xl bg-black">
    <svg
      class="h-3 w-3 transition-all duration-300 md:h-5 md:w-5"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <line
        id="Line_1"
        data-name="Line 1"
        y2="20"
        transform="translate(10)"
        fill="none"
        stroke="#fff"
        stroke-width="4"
        stroke-linecap="round"
      />
      <line
        id="Line_2"
        data-name="Line 2"
        y2="20"
        transform="translate(20 10) rotate(90)"
        fill="none"
        stroke="#fff"
        stroke-width="4"
        stroke-linecap="round"
      />
    </svg>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped></style>
